__webpack_require__.p = "/ai-assistant.github.io/";